import ListSkills from './ListSkills';
import { SKILLS } from "../data/resumeData";

function Skills() {
    return (
      <section className="skills fade-in">
        <h2>Skills</h2>
        <div className="card">
            <ListSkills items={SKILLS} />
        </div>
      </section>
    );
  }
  
  export default Skills;